import { render, staticRenderFns } from "./objected-parties-modal.vue?vue&type=template&id=24841cfc&scoped=true&"
import script from "./objected-parties-modal.vue?vue&type=script&lang=js&"
export * from "./objected-parties-modal.vue?vue&type=script&lang=js&"
import style0 from "./objected-parties-modal.vue?vue&type=style&index=0&id=24841cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24841cfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
